import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  userInviteConfirmFailure,
  userInviteConfirmStart,
  userInviteConfirmSuccess
} from "../actions/invitations/invitations";
import { AppDispatch } from "../reducers";
import { UserClaims } from "../types/users";

export type ConfirmPasswordResetSlice = {
  passwordResetToken: string;
  ucToken: string;
  user: UserClaims | Record<string, never>;
  newPassword: string;
  sendingRequest: boolean;
  checkPasswordResetTokenFailed: boolean;
  checkPasswordResetTokenFailedMessage: string;
  checkPasswordResetTokenSucceeded: boolean;
  confirmPasswordResetFailed: boolean;
  confirmPasswordResetFailedMessage: string;
};

const initialState: ConfirmPasswordResetSlice = {
  passwordResetToken: "",
  ucToken: "",
  user: {}, //UserClaims
  newPassword: "",
  sendingRequest: false,
  checkPasswordResetTokenFailed: false,
  checkPasswordResetTokenFailedMessage: "",
  checkPasswordResetTokenSucceeded: false,
  confirmPasswordResetFailed: false,
  confirmPasswordResetFailedMessage: ""
};

const confirmPasswordResetSlice = createSlice({
  name: "confirmPasswordReset",
  initialState,
  reducers: {
    setPasswordResetToken(state, action: PayloadAction<string>) {
      state.passwordResetToken = action.payload;
    },
    checkPasswordResetTokenStart(state) {
      state.user = {};
      state.checkPasswordResetTokenFailed = false;
      state.checkPasswordResetTokenFailedMessage = "";
      state.checkPasswordResetTokenSucceeded = true;
      state.sendingRequest = true;
    },
    checkPasswordResetTokenSuccess(
      state,
      action: PayloadAction<{ ucToken: string; user: UserClaims }>
    ) {
      state.ucToken = action.payload.ucToken;
      state.user = action.payload.user;
      state.checkPasswordResetTokenFailed = false;
      state.checkPasswordResetTokenFailedMessage = "";
      state.checkPasswordResetTokenSucceeded = true;
      state.sendingRequest = false;
    },
    // Note: this action is not used
    checkPasswordResetTokenFailed(state, action: PayloadAction<string>) {
      state.ucToken = "";
      state.user = {};
      state.checkPasswordResetTokenFailed = true;
      state.checkPasswordResetTokenFailedMessage = action.payload;
      state.checkPasswordResetTokenSucceeded = false;
      state.sendingRequest = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    passwordResetConfirmStart(_state, _action: PayloadAction<string>) {
      /** unused */
    },
    passwordResetConfirmSuccess() {
      /** unused */
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    passwordResetConfirmFailed(_state, _action: PayloadAction<string>) {
      /** unused */
    }
  },
  extraReducers: builder => {
    builder
      .addCase(userInviteConfirmStart, state => {
        // Note: These three fields do not belong to this slice, and are not used anywhere.
        // state.confirmUserInviteFailed = false;
        // state.confirmUserInviteFailedMessage = "";
        // state.confirmUserInviteFailedSucceeded = false;
        state.sendingRequest = true;
      })
      .addCase(userInviteConfirmSuccess, state => {
        // Note: These three fields do not belong to this slice, and are not used anywhere.
        // state.confirmUserInviteFailed = false;
        // state.confirmUserInviteFailedMessage = "";
        // state.confirmUserInviteFailedSucceeded = true;
        state.sendingRequest = false;
      })
      .addCase(userInviteConfirmFailure, state => {
        // Note: These three fields do not belong to this slice, and are not used anywhere.
        // state.confirmUserInviteFailed = true;
        // state.confirmUserInviteFailedMessage = action.payload.message;
        // state.confirmUserInviteFailedSucceeded = false;
        state.sendingRequest = false;
      });
  }
});

export const checkPasswordResetTokenSuccess = (ucToken: string, user: UserClaims) => (
  dispatch: AppDispatch
) => dispatch(confirmPasswordResetSlice.actions.checkPasswordResetTokenSuccess({ ucToken, user }));

export const {
  setPasswordResetToken,
  checkPasswordResetTokenStart,
  passwordResetConfirmStart,
  passwordResetConfirmSuccess,
  passwordResetConfirmFailed
} = confirmPasswordResetSlice.actions;

export default confirmPasswordResetSlice.reducer;
